<template>
    <div class="recommend" data-cy="recommend">
        <template v-for="(item, i) in items" :key="i">
            <ObjectsTextTooltip v-if="item.tooltip" :text="item.tooltip" class="wwwwww">
                <div class="recommend__item">
                    <div class="recommend__name"><span v-html="item.name"></span> <span v-if="(item.name + '').length === 1">✭</span></div>
                    <div class="recommend__progress">
                        <div class="recommendLine">
                            <span class="recommendLine__bg" />
                            <span v-if="item.progress > 0" class="recommendLine__active" :style="`width: ${item.progress}%;`"></span>
                        </div>
                    </div>
                    <div class="recommend__count" :class="countClassName">
                        {{ item.count }}
                    </div>
                </div>
            </ObjectsTextTooltip>
            <template v-else>
                <div class="recommend__item">
                    <div class="recommend__name"><span v-html="item.name"></span> <span v-if="(item.name + '').length === 1">✭</span></div>
                    <div class="recommend__progress">
                        <div class="recommendLine">
                            <span class="recommendLine__bg" />
                            <span v-if="item.progress > 0" class="recommendLine__active" :style="`width: ${item.progress}%;`"></span>
                        </div>
                    </div>
                    <div class="recommend__count" :class="countClassName">
                        {{ item.count }}
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import RatingProgressBar from '~/models/Product/RatingProgressBar'

export default {
    props: {
        items: {
            type: Array as PropType<RatingProgressBar[]>,
            required: true,
        },
        countClassName: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
/*
Structure:
    .recommend(.recommend--question)
        .recommend__name
        .recommend__count(.recommend__count--silver)
*/
.recommend {
    //display: grid;
    //grid-template-columns: fit-content(20%) auto fit-content(10%);
    //align-items: center;
    //gap: 8px 15px;
    //line-height: 25px;

    //@include screen-md {
    //    gap: 8px 35px;
    //    grid-template-columns: fit-content(10%) auto fit-content(10%);
    //}

    &__item {
        display: grid;
        grid-template-columns: fit-content(20%) auto 40px; //fit-content(10%);
        align-items: center;
        line-height: 25px;
        gap: 8px 15px;

        @include screen-md {
            gap: 8px 30px;
            //grid-template-columns: fit-content(10%) auto fit-content(10%);
        }
    }

    &--question {
        .recommend__item {
            gap: 8px 20px;
            grid-template-columns: 50% auto fit-content(10%);
        }

        .recommend__name {
            font-weight: 400;
        }
    }

    .wwwwww {
        display: block !important;
        border: 0 !important;
        margin: 0 !important;
    }
}

.recommend__name {
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    color: $color-cta-dark;
    text-align: right;
}

.recommend__count {
    font-size: 14px;
    color: $color-cta-dark;

    &--silver {
        color: $color-cta-dark;
    }
}

.recommendLine {
    position: relative;
}

.recommendLine__bg {
    display: block;
    //border: 1px solid $color-grey-dark;
    background-color: $color-tercial-light-green-2;
    height: 4px;
    border-radius: 50px;
    width: 100%;
}

.recommendLine__active {
    display: block;
    background-color: $color-secondary-dark-green-1;
    height: 4px;
    border-radius: 50px;
    position: absolute;
    left: 0;
    top: 0;
    //border: 2px solid $color-yellow;
    min-width: 12px;
}

.recommend--nutra-rating {
    .recommend__item {
        grid-template-columns: 40% auto 50px;
    }

    .recommend__name {
        text-align: left;
        line-height: 35px;
        font-weight: 500;
    }
}
</style>
